import * as ActionsConstants from "../Constants/index";
import { DEFAULT_ORDERS_FILTERS } from "../Constants/index";

const InitialState = {
	orders: [],
	ownerKey: null,
	scrollTop: 0,
	filters: { ...DEFAULT_ORDERS_FILTERS },
	limitReached: false,
};

export const orders = (state = InitialState, action) => {
	switch (action.type) {
		case ActionsConstants.SET_ORDERS:
			return {
				...state,
				orders: action.data,
			};

		case ActionsConstants.SET_ORDERS_OWNER_KEY:
			return {
				...state,
				ownerKey: action.data,
			};

		case ActionsConstants.SET_ORDERS_SCROLL_TOP:
			return {
				...state,
				scrollTop: action.data,
			};

		case ActionsConstants.SET_ORDERS_FILTERS:
			return {
				...state,
				filters: action.data,
			};

		case ActionsConstants.SET_LIMIT_REACHED:
			return {
				...state,
				limitReached: action.data,
			};

		case ActionsConstants.CLEAR_STATE:
			return {
				...InitialState,
				filters: { ...DEFAULT_ORDERS_FILTERS },
			};

		default:
			return {
				...state,
			};
	}
};

export default orders;
